
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ve-chung-toi",
      function () {
        return require("private-next-pages/ve-chung-toi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ve-chung-toi"])
      });
    }
  